import { Utils } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning";
import { Icon } from "@lightningjs/ui-components";

export interface LoadingIconTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class LoadingIcon
  extends Lightning.Component
  implements Lightning.Component<LoadingIconTemplateSpec>
{
  _rotateAnimation = null
  static override _template(): Lightning.Component.Template<LoadingIconTemplateSpec> {
    return {
      w: (w) => w,
      h: (h) => h,
      flex: { alignItems: 'center', justifyContent: 'center' },
      Icon: {
        w: 100,
        h: 100,
        flexItem: { margin: 0 },
        mount: 0.5,
        type: Icon,
        icon: Utils.asset('/images/loading-circle.png'),
      }
    }
  }

  override _init() {
    this._rotateAnimation = this.animation({
      duration: 2,
      repeat: -1,
      stopMethod: "immediate",
      actions: [
        { t: 'Icon',p: 'rotation', v: { sm: 0, 0: 0, 1: 2 * Math.PI } }
      ],
    });
    this._rotateAnimation.start()
  }

}
